import React from 'react';
import propTypes from 'prop-types';
import { TextField } from 'formik-material-ui';
import { Field } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

export const type = "text";
export const label = "MOVE_CONF.NAME_FIELD_PH";
export const defaultValue = '';

export const schema = Yup.string().nullable().min(3, 'Minimum 3 characters').required('Required');

export default function MovementName({ namespace, className, isSubmitting, ...props }) {
  const { t } = useTranslation();
  
  return (
    <Field
      size='small'
      className={className}
      placeholder={t(label)}
      component={TextField}
      name={namespace}
      type={type}
      disabled={isSubmitting}
      onClick={(ev) => ev.stopPropagation()}
    />
  );
}

MovementName.propTypes = {
  namespace: propTypes.string,
  className: propTypes.string,
  isSubmitting: propTypes.bool,
}
